import styled from 'styled-components';

export const PunchupTicketsContainer = styled.div`
	display: flex;
	max-width: 100%;
	align-items: stretch;

	::-webkit-scrollbar {
		display: none;
	}
`;
